import { createAction } from 'typesafe-actions';
import type { PaymentPlan } from '../../configs/APISchemas/QuoteSchema';
import { saveToLocalStorageHelper } from '../../helpers/saveToLocalStorageHelper';
import { localStorageKey } from '../../helpers/validateLocalStorage';
import type {
  PurchasePolicyAdditionalData,
  PurchasePolicyFlow,
  PurchasePolicyInput,
} from '../reducer/v2/purchasePolicy';

export const _resetPurchasePolicy = createAction('purchasePolicy/reset')();

export const resetPurchasePolicy = () => {
  localStorage.removeItem(localStorageKey.purchasePolicyInput);
  localStorage.removeItem(localStorageKey.purchasePolicyFlow);
  localStorage.removeItem(localStorageKey.purchasePolicyAdditionalData);
  return _resetPurchasePolicy();
};

export const _resetPurchasePolicyFlow = createAction(
  'purchasePolicy/reset_flow',
)();

export const resetPurchasePolicyFlow = () => {
  localStorage.removeItem(localStorageKey.purchasePolicyFlow);
  return _resetPurchasePolicyFlow();
};

export const updatePaymentPlans = createAction(
  'purchasePolicy/paymentPlans/update',
)<PaymentPlan[] | null>();

export const _updateCommunityId = createAction(
  'purchasePolicy/communityId/update',
)<string>();

export const updateCommunityId = (
  communityId: string,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'additionalData',
    localStorageKey: localStorageKey.purchasePolicyAdditionalData,
    input: { communityId },
  });
  return _updateCommunityId(communityId);
};

export const _updateUnderwritingCompanyId = createAction(
  'purchasePolicy/underwritingCompanyId/update',
)<string>();

export const updateUnderwritingCompanyId = (
  underwritingCompanyId: string,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'additionalData',
    localStorageKey: localStorageKey.purchasePolicyAdditionalData,
    input: { underwritingCompanyId },
  });
  return _updateUnderwritingCompanyId(underwritingCompanyId);
};

export const _updatePurchasePolicyFlow = createAction(
  'purchasePolicy/update_flow',
)<Partial<PurchasePolicyFlow>>();

export const _updatePurchasePolicyAdditionalData = createAction(
  'purchasePolicy/update_additional_data',
)<Partial<PurchasePolicyAdditionalData>>();

export const _updatePurchasePolicyInput = createAction(
  'purchasePolicy/update_input',
)<Partial<PurchasePolicyInput>>();

export const updatePurchasePolicyInput = (
  input: Partial<PurchasePolicyInput>,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'input',
    localStorageKey: localStorageKey.purchasePolicyInput,
    input,
  });
  return _updatePurchasePolicyInput(input);
};

export const updatePurchasePolicyFlow = (
  input: Partial<PurchasePolicyFlow>,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'flow',
    localStorageKey: localStorageKey.purchasePolicyFlow,
    input,
  });
  return _updatePurchasePolicyFlow(input);
};

export const updatePurchasePolicyAdditionalData = (
  input: Partial<PurchasePolicyAdditionalData>,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'additionalData',
    localStorageKey: localStorageKey.purchasePolicyAdditionalData,
    input,
  });
  return _updatePurchasePolicyAdditionalData(input);
};
